import { Scalars } from 'common/schema/commonSchemaRemoteTypes';
import { HomeArtistsSort } from './filter.types';

export type HomeArtistsFiltersHash = `${HomeArtistsSort}_${string}`;

export const listingDirections = ['BACKWARD', 'FORWARD'] as const;
export type ListDirection = (typeof listingDirections)[0] | (typeof listingDirections)[1];

export const loadingIdentifier = 'LOADING' as const;
export type ListLoadingId = typeof loadingIdentifier;

export type ListLoaderStatus = 'COLD' | 'FINISHED' | 'IDLE' | `${ListLoadingId}_${ListDirection}`;

export type ListWindowLoaderStateType<ValuesType, StatusType> = {
  batchSize: number;
  values: Array<ValuesType>;
  status: StatusType;
  hasMore: [boolean, boolean]; // [backward, forward]
};

export type ListLoaderStateType<Typename extends HomeArtistsSort, CursorType, IdType = Scalars['bigint']> = {
  __typename: Typename;
  listed: ListWindowLoaderStateType<CursorType, ListLoaderStatus>;
  detailed: ListWindowLoaderStateType<IdType, ListLoaderStatus>;
  cursor: [CursorType, CursorType]; // [backward, forward]
  detailedToListedStartOffset: number;
  lastScrollPosition: number;
};

export type HomeArtworksListByDateCursor = {
  contextId: Scalars['bigint'];
  appearedAt: Scalars['date'];
};
export type HomeArtworksListByDate = ListLoaderStateType<'byDate', HomeArtworksListByDateCursor>;

export type HomeArtworksListByTitleCursor = {
  contextId: Scalars['bigint'];
  title: Scalars['String'];
};
export type HomeArtworksListByTitle = ListLoaderStateType<'byTitle', HomeArtworksListByTitleCursor>;

export type ListActionArgs =
  | [ListDirection, HomeArtworksListByDate['__typename'], HomeArtworksListByDate['listed']['values']]
  | [ListDirection, HomeArtworksListByTitle['__typename'], HomeArtworksListByTitle['listed']['values']];

export type DetailActionArgs =
  | [ListDirection, HomeArtworksListByDate['__typename'], HomeArtworksListByDate['detailed']['values']]
  | [ListDirection, HomeArtworksListByTitle['__typename'], HomeArtworksListByTitle['detailed']['values']];

export type HomeArtistsListState = {
  identifier: HomeArtistsFiltersHash;
  type: HomeArtistsSort;
} & (
  | {
      type: 'byDate';
      data: HomeArtworksListByDate;
    }
  | {
      type: 'byTitle';
      data: HomeArtworksListByTitle;
    }
);

export type HomeArtistsListingCursor = HomeArtworksListByDateCursor | HomeArtworksListByTitleCursor;

export const isHomeArtworksListByDateCursor = (
  cursor: HomeArtistsListingCursor
): cursor is HomeArtworksListByDateCursor => (cursor as HomeArtworksListByDateCursor)?.appearedAt !== undefined;

export const isHomeArtworksListByTitleCursor = (
  cursor: HomeArtistsListingCursor
): cursor is HomeArtworksListByTitleCursor => (cursor as HomeArtworksListByTitleCursor)?.title !== undefined;

export const LOADING_STATES: ListLoaderStatus[] = ['LOADING_BACKWARD', 'LOADING_FORWARD'];
